import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DiretyCheckGuard } from 'src/app/shared/guard/direty-check.guard';
import { RolesComponent } from './roles.component';

const routes: Routes = [
  { path: '', component: RolesComponent, canDeactivate: [DiretyCheckGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RolesRoutingModule { }
